var _ellipse, _ellipse2, _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterSource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Interface / Link_Break"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 130",
    cx: 24,
    cy: 25,
    rx: 16,
    ry: 4,
    fill: "#005AC7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 132",
    cx: 24,
    cy: 25,
    rx: 15,
    ry: 3,
    fill: "#E4E6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4766 25.9877C15.335 26.2025 12.5861 23.5716 12.0363 20.2427C11.8531 19.0346 12.4029 17.9876 12.7956 16.9407C14.1569 13.5581 16.0681 10.4976 18.0054 7.46406C18.3719 6.87345 18.7122 6.84659 19.0787 7.38351C21.2255 10.8198 23.5032 14.1755 24.7336 18.095C25.9641 22.0145 22.7701 26.0951 18.4766 25.9877Z",
    fill: "#25A5C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.4838 25.9916C29.3089 26.1385 27.4058 24.3385 27.0252 22.0608C26.8983 21.2342 27.2789 20.5179 27.5508 19.8015C28.4932 17.4871 29.8163 15.3931 31.1576 13.3175C31.4113 12.9134 31.6469 12.895 31.9007 13.2624C33.3869 15.6135 34.9637 17.9096 35.8156 20.5913C36.6674 23.2731 34.4562 26.0651 31.4838 25.9916Z",
    fill: "#25A5C7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13551_16839",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 27,
    width: 32,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 42.3659C40 43.8207 32.644 45 23.876 45C15.1079 45 8 43.8207 8 42.3659C8 40.9111 15.1079 39.7317 23.876 39.7317C32.644 39.7317 40 40.9111 40 42.3659Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 42.3659C8 40.9111 15.1079 39.7317 23.876 39.7317C32.644 39.7317 40 40.9111 40 42.3659V27C35.7829 31.8293 11.4729 30.9512 8 27V42.3659Z",
    fill: "#D9D9D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13551_16839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4496 30.4444C14.4496 29.2171 15.3381 28.2222 16.4341 28.2222C17.5301 28.2222 18.4186 29.2171 18.4186 30.4444V46H14.4496V30.4444Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3721 31.8333C24.3721 30.4526 25.3716 29.3333 26.6047 29.3333C27.8377 29.3333 28.8372 30.4526 28.8372 31.8333V46H24.3721V31.8333Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5814 30.4444C29.5814 29.2171 30.4699 28.2222 31.5659 28.2222C32.6619 28.2222 33.5504 29.2171 33.5504 30.4444V46H29.5814V30.4444Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2946 28.7778C34.2946 27.8573 34.9609 27.1111 35.7829 27.1111C36.6049 27.1111 37.2713 27.8573 37.2713 28.7778V46H34.2946V28.7778Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0155 27.1111C38.0155 26.4975 38.4597 26 39.0078 26C39.5558 26 40 26.4975 40 27.1111V46H38.0155V27.1111Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1628 31.8333C19.1628 30.4526 20.1623 29.3333 21.3953 29.3333C22.6284 29.3333 23.6279 30.4526 23.6279 31.8333V46H19.1628V31.8333Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7287 28.7778C10.7287 27.8573 11.395 27.1111 12.2171 27.1111C13.0391 27.1111 13.7054 27.8573 13.7054 28.7778V46H10.7287V28.7778Z",
    fill: "#005AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 27.1111C8 26.4975 8.44424 26 8.99225 26C9.54025 26 9.9845 26.4975 9.9845 27.1111V46H8V27.1111Z",
    fill: "#005AC7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSource);
export default __webpack_public_path__ + "static/media/waterSource.8250779257388709e9fd5fe4e467fe74.svg";
export { ForwardRef as ReactComponent };